import React, {useEffect, useState} from "react";
import { UpdateFieldFn, Golfer } from "../types/types";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./shared/Footer";
import { SearchMembers } from "../api/api-hook";
import { normalizeInput, formatDOB, convertFromISOToUS, isValidDOB } from "../utils/utils";
import { usePageContent } from "../api/usePageContent";



interface Step2Props {
  formData: Golfer;
  updateField: UpdateFieldFn;
  resetStep: (step: number) => void;
}



interface LocationState {
  golfer?: Golfer;
}

const Step2: React.FC<Step2Props> = ({ formData, updateField, resetStep}) => {
  const { title: pageTitle, overview: pageOverview } = usePageContent("step2");
  const navigate = useNavigate();
  const [results, setResults] = useState<Golfer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasSearched, setHasSearched] = useState(false);
  const location = useLocation();
  const selectedContact = location.state;


  const [emailMessage, setEmailMessage] = useState<string>("");
    
      const state = (location.state || {}) as LocationState;
    
      const [golfer, setGolfer] = useState<Golfer | null>(
        state.golfer ?? null
      );

      console.log(state);
      console.log(location);

  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault();
    setHasSearched(true); 
    setLoading(true);

    // build an updated golfer from the latest formData if you want to be explicit:
    const updatedGolfer: Golfer = {
      ...(golfer ?? {}),
      vip_package: formData.vip_package || "",
      vip_card_type: formData.vip_card_type || "",
    };


    try {
          
            
            const raw = await SearchMembers(formData?.lastName || '', formData?.memberNumber || '');

            const data: Golfer[] =
          typeof raw === "string" ? JSON.parse(raw) : raw;

        
               if (Array.isArray(data)) {
                setResults(data);
                setLoading(false);
              } else {
                setResults([]); // fallback
                setLoading(false);
              }
            } catch (err) {
              console.error("Search error:", err);
              setResults([]);
              setLoading(false);
            }
      




   
  };


const handleFieldChange = (field: keyof Golfer) => 
      (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const value = e.target.value;
    
        // 1. update your global form data
        updateField(field, value);
  
        // 2. also keep local golfer in sync
        setGolfer((prev) => {
          const base = prev ?? {};
    
          // map FormData field name ⇒ Golfer field name
          if (field === "vip_package") {
            return { ...base, vip_package: value };
          }
          if (field === "vip_card_type") {
            return { ...base, vip_card_type: value };
          }
    
          return base;
        });
      };



useEffect(() => {
    if (state.golfer) {
      updateField("firstName", state.golfer?.firstName || "");
      updateField("lastName", state.golfer?.lastName || "");
      updateField("email", state.golfer?.email || "");
      updateField("phone", normalizeInput(state.golfer?.phone));
      updateField("sex", state.golfer?.sex || "");
      if (state.golfer.id) {
        updateField("id", state.golfer.id as any || '');
      }
      if (state.golfer?.date_of_birth && state.golfer?.date_of_birth.includes("-")) {
        updateField("date_of_birth", convertFromISOToUS(state.golfer?.date_of_birth));
      } else {
        updateField("date_of_birth", (state.golfer?.date_of_birth || ""));
      }
      updateField("address", state.golfer?.address || "");
      updateField("street_address_2", state.golfer?.street_address_2 || "");
      updateField("city", state.golfer?.city || "");
      updateField("state", state.golfer?.state || "");
      updateField("zip", state.golfer?.zip || "");

      updateField("bagTag", !!state.golfer?.bagTag);
      updateField("donation", !!state.golfer?.donation);
      updateField("personalization", state.golfer?.personalization || '');
      updateField("donation_amount", state.golfer?.donation_amount || 0);
      
      updateField("vip_card_type", state.golfer?.vip_card_type || "");
      updateField("vip_package", state.golfer?.vip_package || "");
      updateField("ghinNumber", state.golfer?.ghinNumber || "");
      updateField("product_id", state.golfer?.product_id || "");
    }
  }, []); 





  const handleSelect = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log(golfer);
    console.log(results)

    const updatedGolfer: Golfer = {
      ...(golfer ?? {}),
      firstName: results[0].firstName || "",
      lastName: results[0].lastName || "",
      email: results[0].email || "",
      phone: results[0].phone || "",
      sex: results[0].sex || "",
      address: results[0].address || "",
      street_address_2: results[0].street_address_2 || "",
      city: results[0].city || "",
      state: results[0].state || "",
      zip: results[0].zip || "",
      id: results[0].id as any || "",
      date_of_birth: results[0].date_of_birth || "",
      bagTag: formData.bagTag || false,
      donation: formData.donation || false,
      personalization: formData.personalization || "",
      donation_amount: formData.donation_amount || 0,
      vip_package: formData.vip_package || "",
      vip_card_type: formData.vip_card_type || "",
      ghinNumber: results[0].ghinNumber || "",
      product_id: formData.product_id
    };
  
    navigate("/step3", {
      state: {
        ...state,            
        golfer: updatedGolfer,
      },
    });

  }

   const handleMemberNumberChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const digitsOnly = e.currentTarget.value.replace(/\D/g, ""); // remove non-numbers
        updateField("memberNumber", digitsOnly);
      };
  


  return (
    <div className="container mt-5">

      <section className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-12">

          {/* Page Heading */}
          <h3 className="mb-3 text-uppercase">
            {pageTitle || "Purchase a VIP Card"}
          </h3>
          {(pageOverview !== undefined ? pageOverview : "The VIP Card offers golfers exclusive discounted rates at approximately 200 courses throughout Virginia and West Virginia. A portion of the proceeds go to support the VSGA-VIP Scholarship Foundation.") && (
            <p className="mb-4">
              {pageOverview || "The VIP Card offers golfers exclusive discounted rates at approximately 200 courses throughout Virginia and West Virginia. A portion of the proceeds go to support the VSGA-VIP Scholarship Foundation."}
            </p>
          )}

          {/* Grey Bar Section Title */}
          <div
            className="bg-light border px-3 py-2 mb-4 text-uppercase fw-semibold"
            style={{ fontSize: "0.9rem" }}
          >
            Personal Information
          </div>

          {/* Subtitle */}
          <p className="text-center mb-4">
            Let's Find You in the VSGA Database
          </p>

          {/* SEARCH FORM */}
          <form
            className="row gy-3 justify-content-center mb-5"
            onSubmit={handleSubmit}
          >
            <div className="col-md-4">
      <label htmlFor="lastName" className="form-label">Last Name</label>
      <input
        type="text"
        id="lastName"
        className="form-control"
        value={formData.lastName || ""}
        onChange={handleFieldChange("lastName")}
        placeholder="Enter your Last Name"
        required
      />
    </div>

    {/* Member Number (GHIN or VIP Card) */}
    <div className="col-md-4">
      <label htmlFor="memberNumber" className="form-label">VIP Card Number OR Handicap ID (e.g. GHIN Number)</label>
      <input
        type="text"
        id="memberNumber"
        className="form-control"
        value={formData.memberNumber || ""}
        onChange={handleFieldChange("memberNumber")}
        placeholder="Enter your VIP Card Number or Handicap ID"
        onKeyUp={handleMemberNumberChange}
        required
      />
    </div>

    {/* Search Button */}
    <div className="col-md-2">
    <button
      type="submit"
      className="btn btn-primary w-100 align-self-end"
      style={{ marginTop: "30px" }}   // adjusts vertical alignment
    >
      Search
    </button>
  </div>

          </form>

          {loading && (
  <div className="text-center mt-4">
    <div className="spinner-border" role="status"></div>
    <p className="mt-2 text-muted">Searching…</p>
  </div>
)}



          {/* RESULTS TABLE */}
{hasSearched && results.length > 0 && (
  <>
    {results.every((row) => (row as any).alreadyPurchased) ? (
      <div className="text-danger fw-semibold mb-4 text-center">
        Our records indicate you may already have a VIP Card. Please call the VSGA at (804) 378-2300 with any questions.
      </div>
    ) : (
      <div className="table-responsive mb-4">
        <table className="table align-middle">
          <thead>
            <tr className="text-uppercase small text-muted">
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Address</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {results.map((row, index) => (
              <tr key={index}>
                <td>{row.firstName}</td>
                <td>{row.lastName}</td>
                <td>{row.email || ""}</td>
                <td>{row.address}</td>
                <td>
                  {(row as any).isActiveCurrentYear && (
                    <span className="badge rounded-pill" style={{ backgroundColor: "#198754", fontSize: "0.72rem", fontWeight: 600 }}>
                      Active {(row as any).membershipYear || new Date().getFullYear()}
                    </span>
                  )}
                  {(row as any).purchaseSeason && (row as any).purchaseSeason !== (row as any).membershipYear && (
                    <span className="badge rounded-pill ms-1" style={{ backgroundColor: "#8c6e2a", fontSize: "0.72rem", fontWeight: 600 }}>
                      Renewing for {(row as any).purchaseSeason}
                    </span>
                  )}
                </td>
                <td className="text-end">
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={handleSelect}
                  >
                    <span className="rounded-circle d-inline-flex align-items-center justify-content-center">
                      →
                    </span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </>
)}

{/* NOTHING IF NO RESULTS */}
{hasSearched && !loading && results.length === 0 && (
  <>
  <div className="alert alert-warning mt-3 text-center">
  No results found. Please try again.
</div>
<hr className="my-4" />
</> 

)}


{!hasSearched && (
  <hr className="my-4" />
)}

          {/* CREATE NEW ACCOUNT */}
          <div className="text-center mb-5">
            <p className="mb-2">New to the VIP Card Program?</p>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={() => navigate("/step3", { state: {golfer:"", admin: location.state?.admin} })}
            >
              Create New Account
            </button>
          </div>

          {/* BACK BUTTON */}
          <button
            className="btn btn-link text-decoration-none px-0"
            onClick={() => {
              resetStep(1);  // clear everything from step 2
              navigate("/step1", { state: {} });
            }}
          >
            ← Back
          </button>

        </div>
      </div>

      {/* FOOTER NOTE */}
      <Footer />
    </section>



    </div>
  );
};

export default Step2;
